<template>
  <div>
    <template v-if="activeComponent == 'default'">
      <div class="form-row">
        <div class="form-group col-md-3">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              v-model="showShadow"
              type="checkbox"
              id="flexCheckDefault"
            />
            <label class="form-check-label" for="flexCheckDefault">
              Show Shadow
            </label>
          </div>
        </div>
        <div class="form-group col-md-3">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              v-model="showSkeleton"
              type="checkbox"
              id="showSkeleton"
            />
            <label class="form-check-label" for="showSkeleton">
              Show Skeleton
            </label>
          </div>
        </div>
      </div>
    </template>
    <models-inspector
      v-if="activeComponent == 'modelsinspector'"
    ></models-inspector>
    <character-inspector
      v-if="activeComponent == 'characterinspector'"
    ></character-inspector>
    <sound-inspector
      v-if="activeComponent == 'soundinspector'"
    ></sound-inspector>
    <images-inspector
      v-if="activeComponent == 'imagesinspector'"
    ></images-inspector>
    <videos-inspector
      v-if="activeComponent == 'videosinspector'"
    ></videos-inspector>
    <lights-inspector
      v-if="activeComponent == 'lightsinspector'"
    ></lights-inspector>
    <effects-inspector
      v-if="activeComponent == 'effectsinspector'"
    ></effects-inspector>
    <experience-inspector
      v-if="activeComponent == 'experienceinspector'"
    ></experience-inspector>
    <placeholder-inspector
      v-if="activeComponent == 'placeholderinspector'"
    ></placeholder-inspector>
  </div>
</template>
<script>
import modelsInspector from './inspector-wrap/modelsInspector'
import characterInspector from './inspector-wrap/characterInspector'
import soundInspector from './inspector-wrap/soundInspector'
import imagesInspector from './inspector-wrap/imagesInspector'
import videosInspector from './inspector-wrap/videosInspector'
import lightsInspector from './inspector-wrap/lightsInspector'
import effectsInspector from './inspector-wrap/effectsInspector'
import experienceInspector from './inspector-wrap/experienceInspector'
import placeholderinspector from './inspector-wrap/placeholderinspector.vue'
import { db } from '../../../firebaseDB'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    "models-inspector": modelsInspector,
    "character-inspector": characterInspector,
    "sound-inspector": soundInspector,
    "images-inspector": imagesInspector,
    "videos-inspector": videosInspector,
    "lights-inspector": lightsInspector,
    "effects-inspector": effectsInspector,
    "experience-inspector": experienceInspector,
    "placeholder-inspector": placeholderinspector,
  },
  data() {
    return {
      selectedCharecter: '',
      selectedCharecterName: '',
      activeComponent: 'placeholderinspector',
      activeComponentTitle: '',
      activeButton: 'Select Animation',
      charData: []
    }
  },
  created () {
    this.listPropModels()
    this.listFBXModels()
    this.listSounds()
    this.listMediaImages()
    this.listEffects()
    this.openModal ()
    let proRef = db.ref('stories').child('/' + localStorage.getItem('storyId'))
    let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'));
    proRef.once("value")
        .then((snapshot) => {
      let storyData = snapshot.val();
      let nodeDataArray = (
        storyData && storyData.diagram
          ? storyData.diagram.nodeDataArray || []
          : []
      )
        .filter((n) => n.key !== "Start");
     let selectedNodePosition = nodeDataArray.findIndex((n) => n.key == selectedLogic.key);
      if (snapshot.val() && !snapshot.val().json) {
        let updates = {};
        let json = {
          storyName: snapshot.val().title,
          experience:
            snapshot.val().hasOwnProperty("experience") &&
            snapshot.val().experience.hasOwnProperty("type")
              ? snapshot.val().experience.type
              : "ar",
          collaboration: true,
          outputApplication: "iBEGOO Prosumer",
          priviledge: "Prosumer",
          cameraType: "front",
          tracking: "face",
          organizationInfo: {
            organizationID: 1142,
            organizationType: "School",
            organizationName: "Columbia University",
            departmentID: 34,
            departmentName: "Life Sciences",
            classID: 2,
            className: "Biology 101",
          },
          mainStory: {
            nodes: nodeDataArray.map((node, index) => {
              return {
                name: node.key,
                nodeId: index,
                nodeType: "SceneNode",
                nextNodeID: -1,
                startTime: 0,
                endTime: 20,
                nodeElements: [],
              };
            }),
          },
        };
        updates[localStorage.getItem("storyId") + `/json`] = json;
        db.ref("stories")
          .update(updates)
          .then((snapshot) => {});
        console.log("created the inspector");
      } else {
        let json = snapshot.val().json;
        let node = nodeDataArray[selectedNodePosition];
        if (
          selectedLogic.key &&
          node &&
          json &&
          json.mainStory &&
          json.mainStory.nodes &&
          !(json.mainStory.nodes || []).find((n) => (n && n.name) == selectedLogic.key)
        ) {
          let updates = {};
          json.mainStory.nodes[selectedNodePosition] = {
            name: node.key,
            nodeId: selectedNodePosition,
            nodeType: "SceneNode",
            nextNodeID: -1,
            startTime: 0,
            endTime: 20,
            nodeElements: [],
          };
            let previousNodePositionKey = snapshot.val().diagram.linkDataArray.filter((node) => node.to === nodeDataArray[selectedNodePosition].key)[0].from
          if (json.mainStory.nodes.filter( (node) => node.name === previousNodePositionKey).length > 0 && previousNodePositionKey.startsWith('Scene')) {
            let previousNodePosition = json.mainStory.nodes.filter((node) => node.name === previousNodePositionKey)[0].nodeId;
            json.mainStory.nodes[parseInt(previousNodePosition)].nextNodeID = selectedNodePosition;
          }
          updates[localStorage.getItem("storyId") + `/json`] = json;
          db.ref("stories")
            .update(updates)
            .then((snapshot) => {});
          console.log("line 129 created the inspector", updates);
        }
      }
    });
  },
  props: ["showShadow", "showSkeleton", "showComponentType"],
  mounted() {},
  watch: {
    showShadow: function () {
      this.changeShadow();
    },
    showSkeleton: function () {
      this.changeSkeleton();
    },
    showComponentType: function (val) {
      this.activeComponent = val
    },
    charData (val) {
      let activeItem
      for (let i = 0; i < this.characters.length; i++) {
        const char = this.characters[i]
        if (char.active) {
          activeItem = char.objectId
        }
      }
      this.$store.dispatch(
        'updateCharacters',
        val.map(char =>
          char.objectId == activeItem ? { ...char, active: true } : char
        )
      )
    }
  },
  computed: {
    ...mapState(['characters'])
  },
  methods: {
    ...mapActions(['listPropModels','listFBXModels','listSounds','listMediaImages','listEffects']),
    async openModal () {
      let _this = this
          let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'));

      await db
        .ref()
        .child('stories')
        .orderByChild('user_id')
      //  .equalTo(this.$store.state.user.id)
        .on('value', function (snapShot) {
          var selectedId
          if (_this.charData.length) {
            _this.charData.forEach(element => {
              if (element.active) selectedId = element.objectId
            })
          }
          _this.charData = []
          const data = snapShot.val()
          for (const snapShotKey in data) {
             if(_this.$store.state.user.id == data[snapShotKey]['user_id'] || 
            ( data[snapShotKey]['sharedWith'] && data[snapShotKey]['sharedWith'].includes(_this.$store.state.user.id))){
            if (snapShotKey === localStorage.getItem('storyId')) {
              _this.story = data[snapShotKey]
              if (
                _this.story &&
                _this.story.json &&
                _this.story.json.mainStory &&
                _this.story.json.mainStory.nodes
              ) {
                _this.story.json.mainStory.nodes.filter(node => node.name === selectedLogic.key).forEach(value => {
                  if (value.hasOwnProperty('nodeElements')) {
                    value.nodeElements.forEach(value1 => {
                      if (value1.elementType === 'Character') {
                        value1.character.active =
                          value1.character.objectId == selectedId
                        _this.charData.push(value1.character)
                        _this.$root.$emit('changeInspector', 'main')
                      } else if (value1.elementType === 'Object3D') {
                        value1.object3D.active =
                          value1.object3D.objectId == selectedId
                        _this.charData.push(value1.object3D)
                        _this.$root.$emit('changeInspector', 'main')
                      } else if (value1.elementType === 'Object2D') {
                        value1.object2D.active =
                          value1.object2D.objectId == selectedId
                        _this.charData.push(value1.object2D)
                        _this.$root.$emit('changeInspector', 'main')
                      } else if (value1.elementType === 'Sound') {
                        value1.sound.active =
                          value1.sound.objectId == selectedId
                        _this.charData.push(value1.sound)
                        _this.$root.$emit('changeInspector', 'main')
                      } else if (value1.elementType === 'Effect') {
                        value1.effect.active =
                          value1.effect.objectId == selectedId
                        _this.charData.push(value1.effect)
                        _this.$root.$emit('changeInspector', 'main')
                      } else if (value1.elementType === 'Light') {
                        value1.light.active =
                          value1.light.objectId == selectedId
                        _this.charData.push(value1.light)
                        _this.$root.$emit('changeInspector', 'main')
                      }
                    })
                  }
                })
              }
            }
            }
          }
          if (_this.charData.length == 0) {
            // _this.triggerModal()
            // this.$root.$emit('trigger', 0)
          } else {
            _this.isLoading = false
          }
        })
    },
    changeShadow () {
      this.$emit('showShadowChange', { showShadow: this.showShadow })
    },
    changeSkeleton() {
      this.$emit("showSkeletonChange", {
        showSkeletonToggle: this.showSkeleton,
      });
    },
    changeSelectedAnimation(data) {
      this.$emit("showSelectedAnimation", {
        selectedAnimation: data.selectedAnimation,
      });
    },
    changeSelectedModel(data) {
      this.selectedCharecter = data.imageurl;
      this.selectedCharecterName = data.name;
      this.$emit("showSelectedModel", { selectedFbxModel: data.index });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector.vue